import axios from 'axios';

export default {
 
  downloadSalesOrderReportV2(salesOrderId, filename, params){
    let url = process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/sales-orders/"+salesOrderId+"/report";
    return axios({
          url: url,
          method: 'GET',
          params,
          responseType: 'blob', // important
        }).then((response) => {
           const url = window.URL.createObjectURL(new Blob([response.data]));
           const link = document.createElement('a');
           link.href = url;
           // console.log(response);
           link.setAttribute('download', filename); //or any other extension
           document.body.appendChild(link);
           link.click();
        });
  },
  calculateSalesOrderV2(salesOrder, abortSignal){
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/api/latest/admin/sales-orders/calculate", salesOrder, {
      signal: abortSignal
    })
      .then(results=>{
        return results.data;
      })
  },
  duplicateV2 (salesOrderId) {
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/sales-orders/"+salesOrderId)
      .then(results=>{
        return results.data;
      })
  },

  postSalesOrderV2(salesOrder){
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/sales-orders", salesOrder)
      .then(results=>{
        return results.data;
      })
  },
  fetchSalesOrders(params, xPortausInclude){

    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/sales-orders",
      {
        params,
        headers: {
          'X-Portaus-Include': xPortausInclude,
        }
      })
      .then(results=>{
        return results.data;
      })
  },
  getSalesOrderV2(salesOrderId){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/sales-orders/"+salesOrderId)
      .then(results=>{
        return results.data;
      })
  },
  putSalesOrderV2(salesOrderId,salesOrderObject){
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/sales-orders/"+salesOrderId,salesOrderObject)
      .then(results=>{
        return results.data;
      }).catch(err=>{
        if(err.response.data.jse_info!=null && err.response.data.jse_info.errorCode=="CUSTOM_ERROR"){
          return Promise.reject(err.response.data.jse_info.contents);
        }
      })
  },

  deleteSalesOrderV2(salesOrderId){
    // console.log("SalesORderAPI DELETE : ", salesOrderId);
    return axios.delete(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/sales-orders/"+salesOrderId)
      .then(response=>{
        return response.data;
      })
  },

  processV2(salesOrderId, automatic){
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+`/API/latest/admin/sales-orders/${salesOrderId}/packages`, { automatic })
      .then(response=>{
        return response.data;
      })
  },

  declineSalesV2(salesOrderId){
    return axios.delete(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+`/API/latest/admin/sales-orders/${salesOrderId}/packages`)
      .then(response=>{
        return response.data;
      })
  },

  voidSalesV2(salesOrderId, force = false){
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+`/API/latest/admin/sales-orders/${salesOrderId}?action=VOID&force=${force}`)
      .then(results=>{
        return results.data;
      })
  },
  confirmSales(salesOrderId){
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/sales-orders/"+salesOrderId+"?action=CONFIRM")
      .then(results=>{
        return results.data;
      })
  },
  completeSales (salesOrderId) {
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/sales-orders/"+salesOrderId+"?action=COMPLETED")
      .then(results=>{
        return results.data;
      })
  },
  putAction(salesOrderId, action, data) {
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+`/API/latest/admin/sales-orders/${salesOrderId}?action=${action}`, data)
      .then(results=>{
        return results.data;
      })
  },
  unProcessSalesV2(salesOrderId){
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+`/API/latest/admin/sales-orders/${salesOrderId}?action=UNPROCESS`)
      .then(results=>{
        return results.data;
      })
  }

}
